module.exports = __webpack_public_path__ + "assets/img/driver-btn-fe4cb1a9.png";